module.exports = __webpack_public_path__ + "static/GameJam_Collection-9ba7dd43c2d84b1bdb2d245a7a55c5d8.jpg";